module.exports = __webpack_public_path__ + "static/media/minusCircle.01aff020.svg";